import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/kennzeichentypen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierIdentifierType"
      returnRoute="/auswahlfelder/dossierIdentifierType"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierIdentifierTypeRoute = Route;
